// extracted by mini-css-extract-plugin
module.exports = {"underline":"storeCheckoutTotal_underline__1_A7Y"};